export default __webpack_public_path__ + "static/media/grafema_armazem-da-alfandega_06.ebd550ee.jpg";